import { useState, useContext, useRef } from "react"
import ReactDOM from "react-dom"
import { CurrentUserContext } from "../Context/CurrentUserContext"
import "./RepAvatar.css"
import { useUserStatus } from "../Context/useUserStatus"

const toTitle = (s = "") => s.replace(/\w\S*/g, t => t[0].toUpperCase() + t.slice(1).toLowerCase())
const initialsOf = (rep, text) => {
    if (rep) {
        const { firstName, lastName, username } = rep
        if (firstName || lastName)
            return ((firstName?.[0] || "") + (lastName?.[0] || "")).toUpperCase() || "--"

        return (username || "NA").slice(0, 2).toUpperCase()
    }
    if (text) return String(text).slice(0, 2).toUpperCase()
    return "--"
}
const displayNameOf = (rep, text) => {
    if (rep) {
        const { firstName, lastName, username } = rep
        const fullName = `${firstName || ""} ${lastName || ""}`.trim()
        return fullName ? toTitle(fullName) : (username || "--")
    }
    if (text) return String(text)
    return "N/A"
}


const hash = (str = "NA") => {
    let h = 2166136261
    for (let i = 0; i < str.length; i++) h = (h ^ str.charCodeAt(i)) * 16777619
    return Math.abs(h >>> 0)
}
const gradientFrom = (colorSeed = "NA") => {
    const h = hash(colorSeed)
    const h1 = h % 360
    const h2 = (h1 + 37) % 360
    return `linear-gradient(135deg, hsl(${h1} 70% 46%), hsl(${h2} 70% 58%))`
}

export default function RepAvatar({ rep, text, repId = null, keepOpen = false, keepClose = false }) {
    const { currentUser } = useContext(CurrentUserContext)
    const { online } = useUserStatus(repId)

    const displayFullUsername = keepClose ? false : (currentUser?.member?.displayFullUsername || keepOpen)
    const [open, setOpen] = useState(displayFullUsername)
    const avatarRef = useRef(null)

    const name = displayNameOf(rep, text)
    const uname = rep ? (rep?.username ? `@${rep.username}` : "--") : "--"
    const colorSeed = rep?.username || name || "NA"
    const initials = initialsOf(rep, text)

    const handleMouseEnter = () => { if (!displayFullUsername) setOpen(true) }
    const handleMouseLeave = () => { if (!displayFullUsername) setOpen(false) }
    const handleFocus = () => { if (!displayFullUsername) setOpen(true) }
    const handleBlur = () => { if (!displayFullUsername) setOpen(false) }

    const getPopupStyle = () => {
        if (open && avatarRef.current && !displayFullUsername) {
            let rect = avatarRef.current.getBoundingClientRect()
            return {
                position: "fixed",
                left: rect.right,
                top: rect.top - 5,
                zIndex: 1000
            }
        }

        return {}
    }

    return (
        <span id={`main-avatar`} ref={avatarRef} className={`main-avatar${(open && displayFullUsername) ? " main-avatar--open" : ""}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onFocus={handleFocus} onBlur={handleBlur} tabIndex={0}>
            <div className="main-avatar__circle" style={{ backgroundImage: gradientFrom(colorSeed) }}>
                {rep?.avatarUrl ? <img src={rep.avatarUrl} alt={name} /> : (rep || text) ? <p>{initials}</p> : <i className="fa fa-user" aria-label="No representative assigned"></i>}
                {repId && online && <span className="main-avatar__status-dot" title="Online" />}
            </div>
            {open && displayFullUsername ?
                <div className="main-avatar__details">
                    <p className="main-avatar__name">{name || "--"}</p>
                    <p className="main-avatar__username">{uname || "--"}</p>
                </div>
                : <>
                    {open && !displayFullUsername && ReactDOM.createPortal(
                        <div className="main-avatar__details main-avatar__details--portal" style={getPopupStyle()}>
                            <p className="main-avatar__name">{name || "--"}</p>
                            <p className="main-avatar__username">{uname || "--"}</p>
                        </div>,
                        document.body
                    )}
                </>
            }
        </span>
    )
}